import { mapGetters } from 'vuex';

// Cùng rule BE (LessonAccountService): Admin / Manager / Leader xem toàn bộ, còn lại chỉ xem khách của mình
export default {
  computed: {
    ...mapGetters(['currentUser']),
    // Role code có hậu tố phòng ban (Leader_Technology, Manager_ChamSoc) nên chỉ lấy phần trước "_"
    userRoleNames() {
      const accountRoles = this.currentUser?.accountRoles || this.currentUser?.AccountRoles || [];
      const fromAccountRoles = accountRoles.map((r) => {
        const role = r.role || r.Role;
        return role?.code || role?.Code || '';
      });
      const fromRoles = this.currentUser?.roles || this.currentUser?.Roles || [];
      return [...fromAccountRoles, ...fromRoles]
        .filter(Boolean)
        .map((name) => name.split('_')[0].toLowerCase());
    },
    canViewAllCustomers() {
      return this.userRoleNames.some((name) =>
        ['admin', 'superadmin', 'administrator', 'manager', 'leader'].includes(name),
      );
    },
  },
};
